import { render, staticRenderFns } from "./userlogin.vue?vue&type=template&id=2d706981&"
import script from "./userlogin.vue?vue&type=script&lang=js&"
export * from "./userlogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports